import { Button } from "primereact/button";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

export const ConfirmForgotPasswordPage = () => {
    const [url, setURL] = useState('');
    let history = useHistory();

    useEffect(function() {        
        setURL('(This is dummy) https://widyan123.site/#/validate-token-forgot-password/55d369be-0f10-4964-b225-3e95ce09a080');
    }, []);

    async function clickConfirm(event) {
        event.preventDefault();
        history.push('/validate-token-forgot-password/55d369be-0f10-4964-b225-3e95ce09a080');
    } 

    return (
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h5>Confirm Forgot Password Page</h5>
                        <p>The real link confirmation forgot password has been sent to mail. Check your mail!</p>
                        <p>Klik the link below to confirm: </p>
                        <form onSubmit={clickConfirm}>
                            <Button label={url} className="p-button-link mb-2 mr-2"></Button>
                        </form>                    
                    </div>
                </div>
            </div>
        );
}